import { default as viewStateStore } from 'owa-mail-folder-store/lib/store/store';
import { action } from 'satcheljs/lib/legacy';
/*
 * Toggles isDraggedOver state
 * @param isDraggedOver indicates if folder pane is dragged over
*/
export default action('setIsDraggedOverState')(function setIsDraggedOverState(isDraggedOver) {
    viewStateStore.isDraggedOver = isDraggedOver;
});
//# sourceMappingURL=setIsDraggedOverState.js.map